import React from "react";
import { FaComments, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
// , FaMapMarkerAlt 
const Help = () => {
  return (
    <div className="min-h-screen px-4 py-12 font-sans flex items-center justify-center">
      {/* <h1 className="text-xl font-semibold mb-6 border-b pb-2">Contact Us</h1> */}

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 text-center text-sm">
        {/* Chat */}
        <div className="flex flex-col items-center">
          <FaComments className="text-6xl mb-6" />
          <h2 className="font-semibold mb-4">Chat with us</h2>
          <p>Products & Orders: 4 am - 11 pm PT</p>
          <p>7 days a week</p>
        </div>

        {/* Call */}
        <div className="flex flex-col items-center">
          <FaPhoneAlt className="text-6xl mb-6" />
          <h2 className="font-semibold mb- 4">Call us</h2>
          <p>313-739-6812</p>
          <p>Products & Orders: 4 am - 11 pm PT, 7 days a week</p>
          {/* <p>NRC, NTC & .SWOOSH: 8 am - 5 pm PT, Mon - Fri</p> */}
          <p>Company Info & Inquiries: 7 am - 4 pm PT, Mon - Fri</p>
        </div>

        {/* Store */}
        {/* Store */}
        <div className="flex flex-col items-center">
          <FaMapMarkerAlt className="text-3xl mb-4" />
          <h2 className="font-semibold mb-1">Find a Store</h2>
          <p>PΛREΛGON location</p>
          <p className="mt-2">16220 W 7 Mile Rd</p>
          <p>Detroit, MI 48235</p>
          <a href="https://maps.google.com/?q=16220+W+7+Mile+Rd,+Detroit,+MI+48235"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 text-blue-600 hover:text-blue-800">
            Open in Maps →
          </a>
        </div>
      </div>
    </div>
  );
};

export default Help;
